var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Geo } from '@tenderd/schema';
import { useGeo, useHEREMap } from '@tenderd/track-web-utils';
import { Input, List } from 'antd';
import React, { useState } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng, } from 'react-places-autocomplete';
var LocationSearchInput = function () {
    var _a = __read(useState(''), 2), address = _a[0], setAddress = _a[1];
    var geo = useGeo();
    var map = useHEREMap().map;
    var handleSelect = function (address) {
        setAddress(address);
        geocodeByAddress(address)
            .then(function (results) { return __awaiter(void 0, void 0, void 0, function () {
            var latLng;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getLatLng(results[0])];
                    case 1:
                        latLng = _a.sent();
                        map.setCenter(latLng);
                        map.setZoom(15);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) { return console.error('Error', error); });
    };
    return (React.createElement(PlacesAutocomplete, { value: address, onChange: function (e) { return setAddress(e); }, onSelect: function (e) { return handleSelect(e); }, searchOptions: {
            componentRestrictions: {
                country: [geo === Geo.UAE ? 'ae' : geo],
            },
        } }, function (_a) {
        var getInputProps = _a.getInputProps, suggestions = _a.suggestions, getSuggestionItemProps = _a.getSuggestionItemProps, loading = _a.loading;
        return (React.createElement("div", { style: { position: 'relative' } },
            React.createElement(Input, __assign({ size: "large" }, getInputProps({
                placeholder: 'Search for location...',
                className: 'location-search-input',
            }))),
            React.createElement("div", { style: {
                    backgroundColor: '#fff',
                    borderRadius: 8,
                    position: 'absolute',
                    zIndex: 100,
                    marginTop: 10,
                } },
                loading && React.createElement("div", null, "Loading..."),
                suggestions.length > 0 && (React.createElement(List, { bordered: true, size: "small", dataSource: suggestions, renderItem: function (item) { return (React.createElement(List.Item, __assign({}, getSuggestionItemProps(item), { style: { ccursor: 'pointer' } }), item.description)); } })))));
    }));
};
export default LocationSearchInput;
